<div class="dx-card" id="accordion">
  <dx-accordion
    #accordion
    [dataSource]="[{ title: 'Bindery', item: {} }]"
    [collapsible]="true"
    [animationDuration]="300"
    [focusStateEnabled]="false"
    [hoverStateEnabled]="false"
    [selectedIndex]="-1"
    (onSelectionChanged)="onAccordionClick($event)"
  >
    <div *dxTemplate="let itemData of 'title'">
      <h3>
        <span style="padding-left: 0.3em">Bindery</span>
      </h3>
    </div>
    <div *dxTemplate="let itemData of 'item'">
      <dx-form #binderyForm labelMode="floating" class="bindery-form">
        <dxi-item
          itemType="group"
          [colCount]="6"
          [colCountByScreen]="{ xs: 1 }"
        >
          <!-- Bind Style -->
          <dxi-item name="bindStyle" [colSpan]="bindStyleColSpan">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                [dataSource]="bindStyleDataSource"
                [(value)]="selectedBindStyle"
                label="Bind Style"
                displayExpr="displayValue"
                [searchEnabled]="false"
                style="caret-color: transparent"
              ></dx-select-box>
            </div>
          </dxi-item>

          <!-- Headband -->
          <dxi-item name="headband" [colSpan]="3" *ngIf="showHeadband">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                [dataSource]="headbandDataSource"
                [(value)]="selectedHeadband"
                label="Headband"
                displayExpr="displayValue"
                [searchEnabled]="false"
                style="caret-color: transparent"
              ></dx-select-box>
            </div>
          </dxi-item>

          <!-- Pack -->
          <dxi-item name="pack" [colSpan]="6">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                [dataSource]="packDataSource"
                [(value)]="selectedCartonsPackValue"
                label="Pack"
                displayExpr="displayValue"
                [searchEnabled]="false"
                style="caret-color: transparent"
              ></dx-select-box>
            </div>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  </dx-accordion>
</div>
